import { Icon, IconName, Stack, Title, useTheme } from "@introist/react-foundation/v2";
import { HoverableCard } from "../../../../foundation/blocks/HoverableCard";
import { CSSProperties } from "react";

export const SetupCard = ({
  title,
  icon,
  onClick,
  style
}: {
  title?: string;
  icon?: IconName;
  onClick?: () => unknown;
  style?: CSSProperties;
}) => {
  const { theme } = useTheme();

  return (
    <HoverableCard
      variant="blended"
      style={{ padding: "var(--spacing-xxLarge)", width: "100%", ...(style ?? {}) }}
      onClick={onClick}
    >
      <Stack alignItems="center" justifyContent="center">
        {icon && <Icon color={theme.palette.foreground.dimmed} name={icon} />}
        <Title>{title}</Title>
      </Stack>
    </HoverableCard>
  );
};
